












































import Component, { mixins } from "vue-class-component";
import axios from "@/plugins/axios";
import ErrorMixin from "@/mixins/errorMixins";

@Component({
  components: {},
})
export default class Easilys extends mixins(ErrorMixin) {
  public dates = [
    new Date().toISOString().substr(0, 10),
    new Date().toISOString().substr(0, 10),
  ];

  public async DoExport(typeExport?: string) {
    this.$store.dispatch("login/setLoading", true);

    if (this.dates[0] > this.dates[1]) {
      [this.dates[0], this.dates[1]] = [this.dates[1], this.dates[0]];
    }

    const startDate = new Date(this.dates[0]);
    const endDate = this.dates[1] ? new Date(this.dates[1]) : startDate;
    const exportDates = this.generateDateRange(startDate, endDate);

    try {
      const responses =
        typeExport === "dl"
          ? await this.fetchDownloads(exportDates)
          : await this.fetchFtpExports(exportDates);

      if (typeExport === "dl") {
        responses.forEach((response, index) => {
          const blob = new Blob([response.data], { type: "application/zip" });
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.download = `easilys_export_${exportDates[index]}.zip`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        });
      } else {
        responses.forEach((response: any) => this.handleFtpResponse(response));
      }
    } catch (error) {
      this.setErrorFromTxt((error as Error).toString());
    } finally {
      this.$store.dispatch("login/setLoading", false);
    }
  }

  private fetchFtpExports(dates: string[]): Promise<any[]> {
    return Promise.all(
      dates.map((date) =>
        axios.get(`withCredentials/easilys?dateFiscales=${date}`)
      )
    );
  }

  private fetchDownloads(dates: string[]): Promise<any[]> {
    return Promise.all(
      dates.map((date) =>
        axios.get(`withCredentials/easilys/download?dateFiscales=${date}`, {
          responseType: "blob",
        })
      )
    );
  }

  private generateDateRange(start: Date, end: Date): string[] {
    const result: string[] = [];
    const current = new Date(start);
    while (current <= end) {
      result.push(current.toISOString().substr(0, 10));
      current.setDate(current.getDate() + 1);
    }
    return result;
  }

  private handleFtpResponse(response: any) {
    if (response.data.code === 2) {
      this.setSuccess(this.$t("exportOk").toString());
    } else {
      const res = response.data.response;

      if (Array.isArray(res)) {
        res.forEach((item: any) => {
          const msg =
            item && item.message ? item.message.toString() : item.toString();
          this.setErrorsFromTxt(msg);
        });
      } else if (res && typeof res === "object" && "message" in res) {
        const msg = res.message ? res.message.toString() : res.toString();
        this.setErrorFromTxt(msg);
      } else {
        const msg = res ? res.toString() : "Erreur inconnue";
        this.setErrorFromTxt(msg);
      }
    }
  }
}
